import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Activities from './components/Activities';
import Affiliations from './components/Affiliations';
import Contact from './components/Contact';
import Footer from './components/Footer';
import NeuralNetwork from './components/NeuralNetwork';
import ScrollAnimator from './components/ScrollAnimator';
import './App.css';

function App() {
  return (
    <div className="App">
      <NeuralNetwork />
      <ScrollAnimator />
      <Header />
      <Hero />
      <About />
      <Activities />
      <Affiliations />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
